<template>
    <div id="nav">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
                {{ currentUserName }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <br />
                <v-img src="../../assets/background/Kings_international_3308.jpg" height="130px" contain></v-img>
              <br />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
  
        <v-divider></v-divider>
  
        <v-list
          dense
          nav
        >
          <v-list-item
            v-for="item in items"
            :key="item.title"
            link :to="item.path"
            :color="item.color"
          >
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>


    </div>
</template>

<script>
import auth from "../../js/auth"

export default {
    name: "navigation",
    data() {
        return {
            currentUserName: "",
            items: [
              { 
                title: "Home", 
                icon: "mdi-home-outline", 
                path: "/home",
                color: "#2E7D32"
              },
              { 
                title: "Profile", 
                icon: "mdi-account-circle-outline", 
                path: "/profile",
                color: "#00ACC1"
              },
              { 
                title: "My Applications", 
                icon: "mdi-list-status", 
                path: "/myapplications",
                color: "#7CB342"
              },
              { 
                title: "Browse Postings", 
                icon: "mdi-view-grid-plus-outline", 
                path: "/browsepostings",
                color: "#33675E"
              }
            ],
            right: null
        };
    },
    methods: {
        getUserInfo(){
          const that = this;

          var user = auth.get_user();

          that.currentUserName = user.name;
        }
    },
    created(){
      const that = this;
      that.getUserInfo();
    }
}
</script>